module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "padding-top": "120px"
    },
    attrs: {
      "id": "contato"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 center"
  }, [_c('h5', [_vm._v("Contact form:")]), _vm._v(" "), _c('form', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.name),
      expression: "dados.name"
    }],
    staticClass: "validate",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dados.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }],
    staticClass: "validate",
    attrs: {
      "id": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dados.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.mensagem),
      expression: "dados.mensagem"
    }],
    staticClass: "validate",
    attrs: {
      "id": "mensagem",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.mensagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dados.mensagem = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Message")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light",
    attrs: {
      "name": "action"
    },
    on: {
      "click": function($event) {
        _vm.enviar($event)
      }
    }
  }, [_vm._v("Send"), _c('i', {
    staticClass: "material-icons right"
  }, [_vm._v("send")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 center"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h6', [_c('a', {
    staticClass: "black-text",
    attrs: {
      "href": "mailto:juscilan@gmail.com"
    }
  }, [_vm._v("If you prefer by e-mail: juscilan@gmail.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768d2f11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-f-contact.vue
// module id = 421
// module chunks = 1